const CrossIcon = (props) => {
  const { className, color } = props;

  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path d="M1 1L11 11" stroke={`${color?color:"#FFFCF8"}`} strokeWidth="1.5" />
      <path d="M11 1L1 11" stroke={`${color?color:"#FFFCF8"}`} strokeWidth="1.5" />
    </svg>
  )
};

export default CrossIcon;